export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '8b10ab9', dateTime: 1789569685999 };